import * as React from "react"
import * as _ from "lodash"
import * as Highlighter from "react-highlight-words";
import IMealItem from "../models/IMealItem";
import TextInput from "../components/TextInput";
import {AppPlaceholders} from "../utils/AppConstants";

/*
 *  created by aditya on 19/7/2018
 */

export interface MealsContainerProps {
    selectedMeals: IMealItem[];
    meals: IMealItem[];
    onMealSelect: (mealItem: IMealItem) => void;
    onMealRemove: (mealId: string) => void;
}

export interface MealsContainerState {
    filteredMeals: IMealItem[];
    filterText: string;
    currentRangeStart: number;
    pageSize: number;
}

class MealsContainer extends React.Component<MealsContainerProps, MealsContainerState> {
    constructor(props: MealsContainerProps) {
        super(props);
        this.state = {
            currentRangeStart: 0,
            pageSize: 16,
            filteredMeals: props.meals,
            filterText: ""
        }
    }

    nextPage = () => {
        let updatedRangeStart = this.state.currentRangeStart + this.state.pageSize;
        this.setState({
            currentRangeStart: updatedRangeStart
        })
    }

    previousPage = () => {
        let updatedRangeStart = this.state.currentRangeStart - this.state.pageSize;
        this.setState({
            currentRangeStart: updatedRangeStart
        })
    }

    getMealsToDisplay = (): IMealItem[] => {
        let meals = this.state.filteredMeals;
        let mealsToDisplay: IMealItem[] = [];
        if (meals.length) {
            let start = this.state.currentRangeStart;
            let end = (this.state.currentRangeStart + this.state.pageSize) > this.props.meals.length ? this.props.meals.length - 1 : this.state.currentRangeStart + this.state.pageSize;
            mealsToDisplay = meals.slice(start, end)
        }
        return mealsToDisplay;
    }

    updateFilterText = (evt: any) => {
        let filterText = evt.target.value;
        if (filterText !== "") {
            let filteredMeals = this.props.meals.filter(item => item.name.indexOf(filterText) !== -1);
            this.setState({
                filterText,
                filteredMeals,
                currentRangeStart: 0
            })
        } else {
            this.setState({
                filterText: "",
                filteredMeals: this.props.meals,
                currentRangeStart: 0
            })
        }
    }

    render() {
        let selectedMealIds = !_.isEmpty(this.props.selectedMeals) ? this.props.selectedMeals.map(item => item.mealId) : [];
        let mealsToDisplay = this.getMealsToDisplay();
        let hidePrevious = this.state.currentRangeStart === 0;
        let hideNext = this.state.currentRangeStart + this.state.pageSize >= this.state.filteredMeals.length;
        return (
            <div className={"meals-container"}>
                <div className={"meal-filter-container"}>
                    <div className={"action-icons-container"}>
                        {
                            this.props.meals.length > 0 &&
                            <div className={"filter-input-container"}>
                                <TextInput value={this.state.filterText} name={"filter-meals"} onChange={this.updateFilterText} placeholder={AppPlaceholders.FILTER_MEAL}/>
                            </div>
                        }
                        { !hidePrevious ? <div className={""} onClick={this.previousPage}>Previous</div> : null }
                        { !hideNext ? <div className={""} onClick={this.nextPage}>Next</div> : null }
                    </div>
                    {
                        _.map(mealsToDisplay, (mealItem, index) => {
                            let isSelected = selectedMealIds.indexOf(mealItem.mealId) !== -1 ? "selected" : "";
                            return <div className={`meal-item ${isSelected}`} onClick={() => this.props.onMealSelect(mealItem)}>
                                    <div>
                                        <Highlighter
                                            highlightClassName="highlighted-filter-text"
                                            searchWords={[this.state.filterText]}
                                            autoEscape={true}
                                            textToHighlight={mealItem.name} />
                                    </div>
                                    <div className={"total-calories-container"}>
                                        <span className={"calorie-label"}>Calories : </span>
                                        <span className={"calorie-value brandon-bold"}>{mealItem.nutritionInfo.calories.toFixed(2)} kcal</span>
                                    </div>
                                </div>
                        })
                    }
                    {
                        mealsToDisplay.length === 0 &&
                        <div>No meals found</div>
                    }
                </div>
            </div>
        )
    }
}

export default MealsContainer;